import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import OnePage from './pages/OnePage';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import Portfolio from './pages/Portfolio';
import Security from './pages/Security';
import About from './pages/About';
import Process from './pages/Process';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import WebsiteDemo from './pages/WebsiteDemo';
import ForGood from './pages/ForGood';

function App() {
    return (
        <div className="App" data-testid="app-root">
            <BrowserRouter>
                <Navbar />
                <Routes>
                    <Route path="/" element={<OnePage />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/portfolio" element={<Portfolio />} />
                    <Route path="/security" element={<Security />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/process" element={<Process />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/website-demo" element={<WebsiteDemo />} />
                    <Route path="/for-good" element={<ForGood />} />
                    <Route path="*" element={<OnePage />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
